import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ e.createElement("path", { d: "M16.8 9.21285L14.0129 12L16.8 14.787L14.787 16.8L12 14.0129L9.21285 16.8L7.19995 14.787L9.98705 12L7.19995 9.21285L9.21285 7.19995L12 9.98705L14.787 7.19995L16.8 9.21285Z", fill: "white" }));
export {
  r as ReactComponent
};
